export default class PassParam {
  private _passwordA: string;
  private _passwordB: string;
  private _token: string;

  constructor(passwordA = '', passwordB = '', token = '') {
    this._passwordA = passwordA;
    this._passwordB = passwordB;
    this._token = token;
  }

  get passwordA(): string {
    return this._passwordA;
  }

  get passwordB(): string {
    return this._passwordB;
  }

  get token(): string {
    return this._token;
  }
}
